import GoogleReviewsSectionImplementation from '../implementation/sections/GoogleReviewsSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiGoogleReviewsSectionDTO,
  GoogleReviewsSectionDTO,
} from '@lib/strapi/dtos/components/sections/googleReviewsSection.dto';

const GoogleReviewsSection = (props: ComponentProps<GoogleReviewsSectionDTO>) => {
  return <GoogleReviewsSectionImplementation {...props}></GoogleReviewsSectionImplementation>;
};

export default GoogleReviewsSection;
